import { FunctionComponent, h } from 'preact';
import Spinner from '../spinner/spinner';

interface Props {
	applyTheme?: boolean;
}

const Loading: FunctionComponent<Props> = ({ applyTheme = true }) => (
	<Spinner className="floating-spinner" applyTheme={applyTheme} float={true} />
);

export default Loading;
